import React, { useEffect } from 'react';
import { IMarketplaceTilesConfigHeader } from 'src/typings/marketplace';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import { useStyles } from 'src/components/profileComponents/Marketplace/components/Common/styles';
import {
  GroupWrapperCollapseState,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction/types';
import { translations } from 'src/constants/translations';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import { IComplexProperty } from 'src/components/profileComponents/Marketplace/types';
import {
  IDevelopmentSpecificationPropChange,
} from 'src/components/profileComponents/Complexes/components/ProjectSpecification/types';
import Box from '@mui/material/Box';

interface Props {
  item: IMarketplaceTilesConfigHeader
  lang: string;
  complexPropertyOptions: IDevelopmentSpecificationPropChange<IComplexProperty | null>[]
  onChange: (item: IMarketplaceTilesConfigHeader) => void,
}
export const TileHeader: React.FC<Props> = ({
  item, lang, complexPropertyOptions, onChange,
}) => {
  const mainStyles = useStyles();
  const [collapseState, setCollapseState] = React.useState<GroupWrapperCollapseState>(GroupWrapperCollapseState.OPEN);
  const [rocketState, setRocketState] = React.useState<boolean>(item.isActive);

  useEffect(() => {
    setRocketState(item.isActive);
  }, [item]);

  const rocketChange = (state: boolean) => {
    onChange({ ...item, isActive: state });
    setRocketState(state);
  };

  return (
    <Box style={{ backgroundColor: 'white' }}>
      <GroupWrapper
        name="Header"
        customStyles={!rocketState ? mainStyles.customGroupWrapperStyles : undefined}
        actions={(
          <GroupWrapperFiltersAction
            collapseState={collapseState}
            rocketState={rocketState}
            onRocket={rocketChange}
            onCollapse={(state) => setCollapseState(state)}
          />
        )}
      >
        { collapseState === GroupWrapperCollapseState.OPEN && item.property?.systemName && (
        <BoxFormAutocomplete
          label={translations.chooseProperty}
          name="property"
          defaultValue={{ label: item.property?.translates?.[lang] || item.property?.systemName, value: item.property }}
          onChange={(event: IDevelopmentSpecificationPropChange<IComplexProperty>) => {
            onChange({ ...item, property: event.value });
          }}
          options={complexPropertyOptions}
        />
        )}
      </GroupWrapper>
    </Box>
  );
};
